
export default function (Component) {
  Component.options.__source = "src/views/basic/roadProduction/routeTable.vue"
}
